import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { BELLE_PROPERTY_META } from "./meta.ts";
import { parseBellePropertyDetailHtml } from "./parser.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const BELLE_PROPERTY_ADAPTER = defineSoldOnlyAdapter(BELLE_PROPERTY_META, buildSearchUrl, {
  parseDetailHtml: parseBellePropertyDetailHtml,
});
